import { render, staticRenderFns } from "./header-lang.vue?vue&type=template&id=8a9b15e8&scoped=true&"
import script from "./header-lang.vue?vue&type=script&lang=js&"
export * from "./header-lang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9b15e8",
  null
  
)

export default component.exports